import React from "react";
import TextFetcher from "./text_render";

const AudioHistory = ({ storageLocation, baseUrl = "https://tecom.pro", textUrl, saochep }) => {
    if (!storageLocation) {
        return null;
    }

    const audioUrl = `${baseUrl}/${storageLocation}`;

    if (textUrl) {
        return <TextFetcher saochep={saochep} url={textUrl} />;
    }

    return (
        <>
            <audio controls className="w-full">
                <source src={audioUrl} type="audio/mpeg" />
                Your browser does not support the audio element.
            </audio>
            <a href={audioUrl} target="_blank" rel="noopener noreferrer">
                <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 mt-2 px-2 rounded">
                    Tải
                </button>
            </a>
        </>
    );
};

export default AudioHistory;
